import React from 'react';
import upSideDownArrow from '../../../../assets/img/svg/table/sort.svg';
import dots from '../../../../assets/img/svg/table/menu-dots-vertical.svg';
import { t } from 'i18next';

interface TableHeaderProps {
  column: string;
}

const TableHeader: React.FC<TableHeaderProps> = ({ column }) => {
  return (
    <div className={`table_header ${column === t('cashRegister.table.header.actions') ? 'table_header_image' : ''}`}>
      <div className="table_row">
        <div key={column} className="table_cell">
          <div className="header_cell_content">
            <span className="header_title">{column}</span>
            <img className="sort_icon" src={upSideDownArrow} alt="Sort" />
          </div>
          <img className="header_menu_icon" src={dots} alt="Menu" />
        </div>
      </div>
    </div>
  );
};
export default TableHeader;
